import React from "react";
import { Routes, Route } from "react-router-dom";
import CreatorLayout from "./components/CreatorLayout";
import DashboardPage from "./pages/DashboardPage";
import ContentHubPage from "./pages/ContentHubPage";
import MediaLibraryPage from "./pages/MediaLibraryPage";
import MonetizationHubPage from "./pages/MonetizationHubPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import EngagementHubPage from "./pages/EngagementHubPage";
import WalletPage from "./pages/WalletPage";
import SettingsPage from "./pages/SettingsPage";
import AudienceCRMPage from "./pages/AudienceCRMPage";
import AdnakianGroupsPage from "./pages/AdnakianGroupsPage";
import LivestreamStudioPage from "./pages/LivestreamStudioPage";

const CreatorRoutes = () => {
  return (
    <Routes>
      <Route element={<CreatorLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="content" element={<ContentHubPage />} />
        <Route path="media" element={<MediaLibraryPage />} />
        <Route path="audience" element={<AudienceCRMPage />} />
        <Route path="groups" element={<AdnakianGroupsPage />} />
        <Route path="engagement" element={<EngagementHubPage />} />
        <Route path="broadcast" element={<EngagementHubPage />} />
        <Route path="monetization" element={<MonetizationHubPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="crm" element={<AudienceCRMPage />} />
        <Route path="wallet" element={<WalletPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="live" element={<LivestreamStudioPage />} />
      </Route>
    </Routes>
  );
};

export default CreatorRoutes;
